import React from 'react'
import { Col, Row } from 'rsuite'
import ProgressDataCard from './ProgressDataCard'
import ClusterChart from './ClusterChart'

export default function ProjectAllCharts({ schema, ...props }) {
  return (
    <div>
      <ClusterChart schema={schema} />

      <Row style={{ marginTop: 10 }}>
        <Col align="center" style={{ backgroundColor: schema.color, borderRadius: 10 }}>
          <p style={{ fontSize: '2rem', color: '#fff', paddingTop: 20, paddingBottom: 20 }}>
            <b>{schema.name}</b>
          </p>
        </Col>
      </Row>

      <ProgressDataCard schema={schema.data1} />
      <ProgressDataCard schema={schema.data2} />
    </div>
  )
}
